import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AvisoService } from '../../../services/aviso/aviso.service';
import { ModalService } from '../../../services/modal.service';
import { finalize, lastValueFrom } from 'rxjs';
import { CommonModule, DatePipe } from '@angular/common';
import { AvisoDetalhado } from '../../../models/AvisoDetalhado';
import { ActivatedRoute, Router } from '@angular/router';
import { SuccessSnackbar } from '../../../components/snackbar/success-snackbar/success-snackbar';
import { clearPaginas, pushPaginaAtiva } from '../../../shared/activePage';

@Component({
  selector: 'app-detalhes-aviso',
  imports: [MatButtonModule, MatProgressSpinnerModule, CommonModule],
  templateUrl: './detalhes-aviso.html',
  styleUrl: './detalhes-aviso.scss',
  providers: [DatePipe],
})
export class DetalhesAviso implements OnInit {
  aviso: AvisoDetalhado = new AvisoDetalhado();
  originalStatus: string = '';
  isLoading = false;

  gruposSelecionados: any[] = [];
  empresasSelecionadas: any[] = [];
  usuariosSelecionados: any[] = [];
  pessoasSelecionadas: any[] = [];

  constructor(
    private avisoService: AvisoService,
    private modalService: ModalService,
    private snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    clearPaginas();
    pushPaginaAtiva({
        nome: 'Home',
        rota: '/home'
    });
    pushPaginaAtiva({
        nome: 'Avisos cadastrados',
        rota: '/avisos'
    });
    pushPaginaAtiva({
        nome: 'Visualizar aviso',
        rota: ''
    });
    const idDaRota = this.route.snapshot.paramMap.get('id');

    if (idDaRota) {
      const idNumerico = +idDaRota;
      this.getAvisoDetalhado(idNumerico);
    } else {
      console.error('ID não encontrado na rota!');
    }
  }

  async getAvisoDetalhado(id: number) {
    this.isLoading = true;
    try {
      const observableAviso = this.avisoService.getAvisoDetalhesById(id).pipe(
        finalize(() => {
          this.isLoading = false;
        })
      );

      const aviso = await lastValueFrom(observableAviso);

      this.originalStatus = aviso.status ? aviso.status.toLowerCase() : '';

      const statusFormatado = aviso.status
        ? aviso.status.charAt(0).toUpperCase() +
          aviso.status.slice(1).toLowerCase()
        : '-';

      const dataFormatada = this.datePipe.transform(
        aviso.dataAgendamento,
        'dd/MM/yyyy - HH:mm'
      );

      this.gruposSelecionados = aviso.grupos.filter(
        (g: any) => !!g.selecionado
      );

      this.empresasSelecionadas = aviso.empresas.filter(
        (g: any) => !!g.selecionado
      );

      this.usuariosSelecionados = aviso.usuarios.filter(
        (g: any) => !!g.selecionado
      );

      this.pessoasSelecionadas = aviso.pessoas.filter(
        (g: any) => !!g.selecionado
      );

      this.aviso = {
        ...aviso,
        status: statusFormatado,
        dataAgendamento: dataFormatada!,
      };
    } catch (error) {
      console.error('Erro ao obter detalhes do aviso:', error);
      this.modalService.openError(
        'Erro ao carregar aviso',
        'Não foi possível carregar os detalhes do aviso. Tente novamente.'
      );
    }
  }

  removerAviso() {
    const id = this.aviso.id;
    if (!id) {
      this.modalService.openError(
        'Erro',
        'ID do aviso não encontrado para remoção.'
      );
      return;
    }

    this.modalService
      .openDeleteConfirmation(
        'Remover aviso',
        `Ao remover o aviso, ele deixará de estar visível para os destinatários, mas continuará disponível para consulta na sua lista de avisos.`
      )
      .subscribe((result) => {
        if (result === 'delete') {
          this.avisoService.removerAvisos([id]).subscribe({
            next: () => {
              this.showSuccessSnackbar('O aviso foi removido com sucesso.');
              this.router.navigate(['/avisos']);
            },
            error: (err) => {
              console.error('Erro ao remover aviso:', err);
              this.modalService.openError(
                'Erro ao remover aviso',
                'Não foi possível remover o aviso. Tente novamente mais tarde.'
              );
            },
          });
        }
      });
  }

  editarAviso(id: number) {
    this.router.navigateByUrl('avisos/editar/' + id);
  }

  getStatusClass(): string {
    return this.originalStatus;
  }

  canRemoveAviso(): boolean {
    return (
      this.originalStatus === 'rascunho' || this.originalStatus === 'agendado'
    );
  }
  isNosStatusRascunho(): boolean {
    return this.originalStatus === 'rascunho';
  }

  podeEditar(): boolean {
    return this.originalStatus === 'rascunho';
  }

  showSuccessSnackbar(message: string): void {
    this.snackBar.openFromComponent(SuccessSnackbar, {
      data: { message: message },
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}
